import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";
import { SenderType } from "@/commons/models/Resident";
import { FamilyPermittedFunctions } from "./Families";

/**
 * ### 待機者 API 操作クラス
 */
export default class WaiterFamilies {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET WaiterFamilies
   */
  public async getsInFacility(
    userStore: LoginUser,
    queryParams?: {
      startIndex?: number;
      endIndex?: number;
      sortKey: string;
      order: string;
      senderType?: SenderType;
    }
  ): Promise<Array<WaiterFamiliesGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterFamilies, formatParams);
    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<Array<WaiterFamiliesGetModel>>(userStore, requestUrl, this.constructor.name, params, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface WaiterFamiliesGetModel {
  /** 施設を示す ID */
  facilityId: number;
  /** ソートキー (residentId)_(familyId) */
  residentsSortKey: string;
  /** 利用者ID */
  id: number;
  /** 家族を示すID */
  familyId: number;

  /** 利用者または家族の誕生日(YYYYMMDDhhmmssSSS) */
  birthday: any;
  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 性別 */
  gender: string;
  /** 登録日時(YYYYMMDDhhmmssSSS) */
  created: number;
  /** 更新日時(YYYYMMDDhhmmssSSS) */
  updated: number;
  /** 利用者名 */
  name: string;
  /** 利用者名（ふりがな） */
  kanaName: string;
  /** 電話番号 */
  tel: string;
  /** 部屋名 */
  roomId: number;
  /** 部屋名 */
  room: string;
  /** 利用者登録用パスワード */
  password: string;
  /** グループID */
  groupId: number;
  /** 家族の氏名 */
  familyName: string;
  /** 家族の電話番号 */
  familyTel: string;
  /** LINEのID */
  familyLineId?: string;
  /** 家族の生年月日 正しくはfamilyBirthdayだが、許容する */
  familyBirthDay: number;
  /** 家族の性別 */
  familyGender: string;
  /** 続柄 */
  familyRelation: string;
  /** 家族の役割 */
  familyPosition: string;
  /** 家族のメッセージ最終投稿日時(YYYYMMDDhhmmssSSS) */
  familyMessageLatestDate: number;
  /** 家族の最終投稿メッセージ内容（テキスト） */
  familyLatestMessage: string;
  /** 送信種別 */
  senderType: SenderType;
  /** 家族のメールアドレス */
  familyMailaddress?: string;
  /** 家族の機能使用可否 */
  familyPermittedFunctions: FamilyPermittedFunctions;
}
